export const version = "strings/5.1.0";
